// Toggle the menu open and close when on mobile
export default function navbar() {
    const burgerButton = document.querySelector('.nav-menu-button');
    const navbar = document.querySelector("nav.navbar")
    if (!navbar) return
    burgerButton?.addEventListener('click', function () {
        navbar.classList.toggle('menu-open');
    });

    const scrollCallback = () => {
        if (window.scrollY <= 1) navbar.classList.remove("scrolled")
        else navbar.classList.add("scrolled")
    }
    scrollCallback()
    window.addEventListener("scroll", scrollCallback)

    const navGroups = document.querySelectorAll("[data-nav-group]")
    navGroups.forEach((group) => {
        let open = false
        const setOpen = () => {
            group.setAttribute("aria-expanded", "true")
            group.classList.add("open")
            open = true
        }

        const setClosed = () => {
            group.setAttribute("aria-expanded", "false")
            group.classList.remove("open")
            open = false
        }

        const toggleOpen = () => {
            if (open) setClosed()
            else setOpen()
        }

        group.addEventListener("click", toggleOpen)
    })

    const navMenus = document.querySelectorAll("[data-nav-menu]")
    navMenus.forEach((menu) => {
        let open = false
        const setOpen = () => {
            menu.setAttribute("aria-expanded", "true")
            menu.classList.add("menu-open")
            navbar.classList.add("menu-open")
            open = true
        }

        const setClosed = () => {
            console.log("CLOSING")
            menu.setAttribute("aria-expanded", "false")
            menu.classList.remove("menu-open")
            navbar.classList.remove("menu-open")
            open = false
        }

        const toggleOpen = () => {
            if (open) setClosed()
            else setOpen()
        }

        document.querySelectorAll("[data-nav-menu-toggle]").forEach((button) => {
            button.addEventListener("click", toggleOpen)
        })

        document.querySelectorAll("[data-nav-menu-onclose]").forEach((closeButton) => {
            closeButton.addEventListener("click", setClosed)
        })

        menu.querySelectorAll("a").forEach((link) => {
            link.addEventListener("click", setClosed)
        })
    })
}
